import {FC, ReactNode} from 'react'
import {IAppsModel} from '../../../../../types/apps/AppsModel'
import {AppItemHeaderControl} from './AppItemHeaderControl'
import {useAccount} from '../../../../../hooks/useAccount'

type Props = {
  app: IAppsModel
}

type WithChildren = {
  children?: ReactNode
}

const AppItemHeaderWrapper: FC<Props & WithChildren> = ({app, children}) => {
  const {currentAccountIdForRequest: accountId, isAgent, isSupervisor} = useAccount()
  const isForeignMember = Boolean(accountId && (isAgent || isSupervisor))

  return (
    <div className='py-3 d-flex flex-stack flex-wrap'>
      <div className='d-flex align-items-center '>{children}</div>
      {!isForeignMember && <AppItemHeaderControl app={app} />}
    </div>
  )
}

export {AppItemHeaderWrapper}
